<template>
  <v-container fluid>
    <v-row>
      <global-EventFilterMenu
        header="Event Filter"
        showStallholders
        headerButtonText="Product Report"
        :headerButtonAction="generateProductReport"
      />
    </v-row>

    <v-row>
      <v-col cols="12" md="6">
        <v-card dark outlined>
          <v-card-title class="secondary py-1 text-subtitle-1">
            <v-icon left dense> mdi-chart-pie </v-icon>
            Total Transactions Volume
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col lg="6" md="12" sm="6" cols="12">
                <v-skeleton-loader
                  elevation="2"
                  type="sentences@6"
                  :loading="productSalesTotalTransactionsLoading"
                >
                  <v-card class="primary mb-2" dark>
                    <v-card-text
                      class="headline font-weight-bold py-0"
                      style="border: 0px solid red"
                    >
                      <div class="subtitle-1">Total Transactions:</div>
                      <!-- 76714 -->
                      {{ productSalesTotalSalesData.TotalTransactions }}
                    </v-card-text>
                  </v-card>

                  <v-card class="primary mb-2" dark>
                    <v-card-text
                      class="headline font-weight-bold py-0"
                      style="border: 0px solid red"
                    >
                      <div class="subtitle-1">Cash:</div>
                      <!-- 2159 -->
                      {{ productSalesTotalSalesData.TotalTransactionsCash }}
                    </v-card-text>
                  </v-card>

                  <v-card class="primary mb-2" dark>
                    <v-card-text
                      class="headline font-weight-bold py-0"
                      style="border: 0px solid red"
                    >
                      <div class="subtitle-1">Card:</div>
                      <!-- 74262 -->
                      {{ productSalesTotalSalesData.TotalTransactionsCard }}
                    </v-card-text>
                  </v-card>

                  <v-card class="primary mb-2" dark>
                    <v-card-text
                      class="headline font-weight-bold py-0"
                      style="border: 0px solid red"
                    >
                      <div class="subtitle-1">Voucher:</div>
                      <!-- 293 -->
                      {{ productSalesTotalSalesData.TotalTransactionsVoucher }}
                    </v-card-text>
                  </v-card>

                  <v-card class="primary mb-2" dark>
                    <v-card-text
                      class="headline font-weight-bold py-0"
                      style="border: 0px solid red"
                    >
                      <div class="subtitle-1">Total Products:</div>
                      <!-- 151132 -->
                      {{ productSalesTotalSalesData.Quantity }}
                    </v-card-text>
                  </v-card>

                  <v-card class="primary mb-2" dark>
                    <v-card-text
                      class="headline font-weight-bold py-0"
                      style="border: 0px solid red"
                    >
                      <div class="subtitle-1">Products Per head</div>
                      <!-- 1.61 -->
                      {{ productSalesTotalSalesData.Productsperhead }}
                    </v-card-text>
                  </v-card>
                </v-skeleton-loader>
              </v-col>
              <v-col lg="6" md="12" sm="6" cols="12">
                <skeletons-graph
                  :loading="productSalesTotalTransactionsLoading"
                >
                  <charts-pie
                    :chartdata="totalTransactionsDonutChartData"
                    :options="options"
                  />
                </skeletons-graph>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card dark outlined>
          <v-card-title class="secondary py-1 text-subtitle-1">
            <v-icon left dense> mdi-chart-pie </v-icon>
            Transactions Volume By Stall
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col
                lg="12"
                md="12"
                sm="12"
                cols="12"
                style="padding-bottom: 20px !important"
              >
                <skeletons-graph
                  :loading="productSalesTotalTransactionsLoading"
                >
                  <charts-pie
                    :chartdata="transactionsStallComparisonDonutChartData"
                    :options="options"
                  />
                </skeletons-graph>
              </v-col>
            </v-row>
          </v-card-text>

          <!-- <v-card-text v-else>
            <label>No data available</label>
          </v-card-text> -->
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card dark outlined>
          <v-card-title class="secondary py-1 text-subtitle-1">
            <v-icon left dense> mdi-chart-line </v-icon>
            Total Transactions Timeline
          </v-card-title>
          <v-card-text>
            <skeletons-graph :loading="productSalesTotalTransactionsLoading">
              <charts-line :chartdata="stallComparisonTimelineChartData" />
            </skeletons-graph>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card dark outlined>
          <v-card-title class="secondary py-1 text-subtitle-1">
            <v-icon left dense> mdi-file-table </v-icon>
            Product Sales Table
          </v-card-title>
          <v-card-text class="pa-0">
            <v-data-table
              v-model="selectedTransaction"
              :headers="headers"
              :items="stallTableData"
            >
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card dark outlined>
          <v-card-title class="secondary py-1 text-subtitle-1">
            <v-icon left dense> mdi-file-table </v-icon>
            Category Sales Table
          </v-card-title>
          <v-card-text class="pa-0">
            <v-data-table
              v-model="selectedTransaction"
              :headers="categoryHeaders"
              :items="categoryTableData"
            >
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card dark outlined>
          <v-card-title class="secondary py-1 text-subtitle-1">
            <v-icon left dense> mdi-file-table </v-icon>
            Product Tags Table
          </v-card-title>
          <v-card-text class="pa-0">
            <v-data-table
              v-model="selectedTransaction"
              :headers="headersOfTagTable"
              :items="productsTagsData"
            >
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import "izitoast/dist/css/iziToast.min.css";
import iziToast from "izitoast/dist/js/iziToast.min.js";

export default {
  data: () => ({
    productSalesTotalSalesData: {
      TotalTransactions: 0,
      TotalTransactionsCash: 0,
      TotalTransactionsCard: 0,
      TotalTransactionsVoucher: 0,
      Quantity: 0,
      Productsperhead: 0,
    },

    totalTransactionsDonutChartData: {
      labels: ["No Data Available"],
      datasets: [
        {
          backgroundColor: [
            "rgb(255, 99, 132)",
            "rgb(54, 162, 235)",
            "rgb(255, 205, 86)",
          ],
          data: [1],
          hoverBorderWidth: 3,
        },
      ],
    },

    transactionsStallComparisonDonutChartData: {
      labels: ["No Data Available"],
      datasets: [
        {
          backgroundColor: [
            "rgb(255, 99, 132)",
            "rgb(54, 162, 235)",
            "rgb(255, 205, 86)",
          ],
          data: [1],
          hoverBorderWidth: 3,
        },
      ],
    },

    stallComparisonTimelineChartData: {
      labels: ["No Data Available"],
      datasets: [
        {
          label: "No Data Available",
          borderColor: "#FF0E00",
          pointBackgroundColor: "white",
          borderWidth: 1,
          pointBorderColor: "#FF0E00",
          backgroundColor: "transparent",
          data: [0],
        },
      ],
    },

    stallTableData: [],

    categoryTableData: [],

    productsTagsData: [],

    selectedTransaction: [],

    headers: [
      { text: "Rank", value: "Rank" },
      { text: "Product Name", value: "Product Name" },
      {
        text: "Quantity",
        value: "Quantity",
        sort: (a, b) =>
          parseFloat(a.replace(/[^0-9.-]+/g, "")) -
          parseFloat(b.replace(/[^0-9.-]+/g, "")),
      },
      {
        text: "Net Sales",
        value: "Net Sales",
        sort: (a, b) =>
          parseFloat(a.replace(/[^0-9.-]+/g, "")) -
          parseFloat(b.replace(/[^0-9.-]+/g, "")),
      },
      {
        text: "Gross Sales",
        value: "Gross Sales",
        sort: (a, b) =>
          parseFloat(a.replace(/[^0-9.-]+/g, "")) -
          parseFloat(b.replace(/[^0-9.-]+/g, "")),
      },
      {
        text: "Per Head",
        value: "Per Head",
        sort: (a, b) =>
          parseFloat(a.replace(/[^0-9.-]+/g, "")) -
          parseFloat(b.replace(/[^0-9.-]+/g, "")),
      },
    ],

    categoryHeaders: [
      { text: "Rank", value: "Rank" },
      { text: "Category Name", value: "Category Name" },
      {
        text: "Quantity",
        value: "Quantity",
        sort: (a, b) =>
          parseFloat(a.replace(/[^0-9.-]+/g, "")) -
          parseFloat(b.replace(/[^0-9.-]+/g, "")),
      },
      {
        text: "Net Sales",
        value: "Net Sales",
        sort: (a, b) =>
          parseFloat(a.replace(/[^0-9.-]+/g, "")) -
          parseFloat(b.replace(/[^0-9.-]+/g, "")),
      },
      {
        text: "Gross Sales",
        value: "Gross Sales",
        sort: (a, b) =>
          parseFloat(a.replace(/[^0-9.-]+/g, "")) -
          parseFloat(b.replace(/[^0-9.-]+/g, "")),
      },
      {
        text: "Per Head",
        value: "Per Head",
        sort: (a, b) =>
          parseFloat(a.replace(/[^0-9.-]+/g, "")) -
          parseFloat(b.replace(/[^0-9.-]+/g, "")),
      },
    ],

    headersOfTagTable: [
      { text: "Rank", value: "Rank" },
      { text: "Tag name", value: "Product Name" },
      {
        text: "Quantity",
        value: "Quantity",
        sort: (a, b) =>
          parseFloat(a.replace(/[^0-9.-]+/g, "")) -
          parseFloat(b.replace(/[^0-9.-]+/g, "")),
      },
      {
        text: "Net Sales",
        value: "Net Sales",
        sort: (a, b) =>
          parseFloat(a.replace(/[^0-9.-]+/g, "")) -
          parseFloat(b.replace(/[^0-9.-]+/g, "")),
      },
      {
        text: "Gross Sales",
        value: "Gross Sales",
        sort: (a, b) =>
          parseFloat(a.replace(/[^0-9.-]+/g, "")) -
          parseFloat(b.replace(/[^0-9.-]+/g, "")),
      },
    ],

    options: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        labels: {
          fontColor: "white",
        },
      },
      tooltips: {
        callbacks: {
          label(tooltipItem, data) {
            const totalValue = data.datasets[0].data.reduce(
              (acc, value) => acc + parseInt(value),
              0
            );
            const currentValue = parseInt(
              data.datasets[0].data[tooltipItem.index]
            );
            const percentage = ((currentValue / totalValue) * 100).toFixed(2);
            return `${data.labels[tooltipItem.index]}: ${
              data.datasets[0].data[tooltipItem.index]
            } (${percentage})%`;
          },
        },
      },
    },
    // loading
    timelineLoading: true,
  }),

  created() {
    var self = this;
    setTimeout(function () {
      self.timelineLoading = false;
    }, 2000);
  },
  filters: {
    currency(value) {
      var formatter = new Intl.NumberFormat("en-AU", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      return "$" + formatter.format(value);
    },
    number(value) {
      var formatter = new Intl.NumberFormat("en-AU", {
        maximumFractionDigits: 0,
      });
      return formatter.format(value);
    },
  },

  computed: {
    ...mapState("dashboard", [
      "productSalesTotalTransactions",
      "productSalesTotalTransactionsLoading",
    ]),
  },

  methods: {
    ...mapActions("dashboard", ["prepareReport", "getReports"]),

    generateProductReport() {
      this.prepareReport("productsReport").then((productReport) => {
        console.log("productReport: ", productReport);
        iziToast.success({
          title: "Product Report",
          message: "Generating product report, standby",
          position: "topRight",
        });
        this.getReports(productReport)
          .then((response) => {
            console.log("getProductReport Response: ", response);
            this.presignedurl = response.S3presignedurl;
            window.open(this.presignedurl, "_blank");
          })
          .catch((err) => {
            console.error(err);
            iziToast.warning({
              title: "Product Report",
              message: "Error getting Product Report, please contact TSG",
              position: "center",
            });
          });
      });
    },

    // ProcessProductSalesTotalTransactionData
    ProcessProductSalesTotalTransactionData() {
      const salesData =
        this.productSalesTotalTransactions?.total_sales_data || {};

      this.productSalesTotalSalesData = {
        TotalTransactions: salesData.TotalTransactions
          ? this.$options.filters.number(salesData.TotalTransactions)
          : 0,
        TotalTransactionsCash: salesData.TotalTransactionsCash
          ? this.$options.filters.number(salesData.TotalTransactionsCash)
          : 0,
        TotalTransactionsCard: salesData.TotalTransactionsCard
          ? this.$options.filters.number(salesData.TotalTransactionsCard)
          : 0,
        TotalTransactionsVoucher: salesData.TotalTransactionsVoucher
          ? this.$options.filters.number(salesData.TotalTransactionsVoucher)
          : 0,
        Quantity: salesData.Quantity
          ? this.$options.filters.number(salesData.Quantity)
          : 0,
        Productsperhead: salesData.Productsperhead || 0,
      };
    },

    // ProcessProductSalesTotalTransactionDataPie
    ProcessProductSalesTotalTransactionDataPie() {
      const comparisonData =
        this.productSalesTotalTransactions?.total_sales_data || {};

      if (comparisonData.TotalTransactionsCash > 0) {
        this.totalTransactionsDonutChartData = {
          labels: ["Cash", "Card", "Voucher"],
          datasets: [
            {
              backgroundColor: [
                "rgb(255, 99, 132)",
                "rgb(54, 162, 235)",
                "rgb(255, 205, 86)",
              ],
              data: [
                comparisonData.TotalTransactionsCash,
                comparisonData.TotalTransactionsCard,
                comparisonData.TotalTransactionsVoucher,
              ],
              hoverBorderWidth: 3,
            },
          ],
        };
      } else {
        this.totalTransactionsDonutChartData = {
          labels: ["No data available"],
          datasets: [
            {
              backgroundColor: [
                "rgb(255, 99, 132)",
                "rgb(54, 162, 235)",
                "rgb(255, 205, 86)",
              ],
              data: [1],
              hoverBorderWidth: 3,
            },
          ],
        };
      }
    },

    // ProcessProductSalesStallComparisonDonutDataPie
    ProcessProductSalesStallComparisonDonutDataPie() {
      const comparisonData =
        this.productSalesTotalTransactions?.stall_comparison_data || [];

      if (comparisonData.length > 0) {
        this.transactionsStallComparisonDonutChartData = {
          labels: comparisonData.map((x) => x["Stall Name"]),
          datasets: [
            {
              backgroundColor: this.$generateColors.getColors(
                comparisonData.length
              ),
              data: comparisonData.map((x) => x.Sales),
              hoverBorderWidth: 3,
            },
          ],
        };
      } else {
        this.transactionsStallComparisonDonutChartData = {
          labels: ["No Data Available"],
          datasets: [
            {
              backgroundColor: ["rgb(255, 99, 132)"],
              data: [1],
              hoverBorderWidth: 3,
            },
          ],
        };
      }
    },

    // ProcessStallComparisonTimelineChartData
    ProcessStallComparisonTimelineChartData() {
      const timelineData =
        this.productSalesTotalTransactions?.stall_comparison_timeline || [];

      if (timelineData.length > 0 && timelineData[0]?.Stalls?.length > 0) {
        this.stallComparisonTimelineChartData = {
          labels: timelineData[0].Stalls.map((obj) => obj.Timestamp),
          datasets: timelineData.map((obj, index) => ({
            label: obj["Stall Name"],
            borderColor: this.$generateColors.getColor(index),
            pointBackgroundColor: "white",
            borderWidth: 3,
            pointBorderColor: this.$generateColors.getColor(index),
            backgroundColor: "transparent",
            data: obj.Stalls?.map((stall) => stall.SalesAmount) || [],
          })),
        };
      } else {
        this.stallComparisonTimelineChartData = {
          labels: ["No Data Available"],
          datasets: [
            {
              label: "No Data Available",
              borderColor: "#FF0E00",
              pointBackgroundColor: "white",
              borderWidth: 1,
              pointBorderColor: "#FF0E00",
              backgroundColor: "transparent",
              data: [0],
            },
          ],
        };
      }
    },

    // ProcessStallTableData
    ProcessStallTableData() {
      const tableData =
        this.productSalesTotalTransactions?.products_table_data || [];
      const headcount =
        this.productSalesTotalTransactions?.event_metadata?.headcount || 1;

      if (tableData.length > 0) {
        this.stallTableData = tableData.map((item) => {
          const quantity =
            item["Quantity"] !== undefined ? item["Quantity"] : 0;
          const perHead =
            headcount > 0 ? (quantity / headcount).toFixed(2) : "0.00";

          return {
            Rank: item["Rank"],
            "Product Name": item["Product Name"],
            Quantity:
              item["Quantity"] !== undefined
                ? this.$options.filters.number(item["Quantity"])
                : "N/A",
            "Net Sales":
              item["Net Sales"] !== undefined
                ? this.$options.filters.currency(item["Net Sales"])
                : "N/A",
            "Gross Sales":
              item["Gross Sales"] !== undefined
                ? this.$options.filters.currency(item["Gross Sales"])
                : "N/A",
            "Per Head": perHead,
          };
        });
      } else {
        this.stallTableData = [];
      }
    },

    // ProcessCategoryTableData
    ProcessCategoryTableData() {
      const categoryData =
        this.productSalesTotalTransactions?.categories_table_data || [];
      const headcount =
        this.productSalesTotalTransactions?.event_metadata?.headcount || 1;

      if (categoryData.length > 0) {
        this.categoryTableData = categoryData.map((item) => {
          const quantity =
            item["Quantity"] !== undefined ? item["Quantity"] : 0;
          const perHead =
            headcount > 0 ? (quantity / headcount).toFixed(2) : "0.00";

          return {
            Rank: item["Rank"],
            "Category Name": item["Category Name"],
            Quantity:
              item["Quantity"] !== undefined
                ? this.$options.filters.number(item["Quantity"])
                : "N/A",
            "Net Sales":
              item["Net Sales"] !== undefined
                ? this.$options.filters.currency(item["Net Sales"])
                : "N/A",
            "Gross Sales":
              item["Gross Sales"] !== undefined
                ? this.$options.filters.currency(item["Gross Sales"])
                : "N/A",
            "Per Head": perHead,
          };
        });
      } else {
        this.categoryTableData = [];
      }
    },

    // ProcessProductTagsTableData
    ProcessProductTagsTableData() {
      const productTagsData =
        this.productSalesTotalTransactions?.tags_table_data || [];

      if (productTagsData.length > 0) {
        this.productsTagsData = productTagsData.map((item) => ({
          Rank: item["Rank"],
          "Tag name": item["Tag name"],
          Quantity:
            item["Quantity"] !== undefined
              ? this.$options.filters.number(item["Quantity"])
              : "N/A",
          "Net Sales":
            item["Net Sales"] !== undefined
              ? this.$options.filters.currency(item["Net Sales"])
              : "N/A",
          "Gross Sales":
            item["Gross Sales"] !== undefined
              ? this.$options.filters.currency(item["Gross Sales"])
              : "N/A",
        }));
      } else {
        this.productsTagsData = [];
      }
    },
  },

  watch: {
    "productSalesTotalTransactions.total_sales_data": {
      handler() {
        this.ProcessProductSalesTotalTransactionData();
        this.ProcessProductSalesTotalTransactionDataPie();
      },
      immediate: true,
    },

    "productSalesTotalTransactions.stall_comparison_data": {
      handler() {
        this.ProcessProductSalesStallComparisonDonutDataPie();
      },
      immediate: true,
    },

    "productSalesTotalTransactions.stall_comparison_timeline": {
      handler() {
        this.ProcessStallComparisonTimelineChartData();
      },
      immediate: true,
    },

    "productSalesTotalTransactions.products_table_data": {
      handler() {
        this.ProcessStallTableData();
      },
      immediate: true,
    },

    "productSalesTotalTransactions.categories_table_data": {
      handler() {
        this.ProcessCategoryTableData();
      },
      immediate: true,
    },

    "productSalesTotalTransactions.tags_table_data": {
      handler() {
        this.ProcessProductTagsTableData();
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
h1 {
  color: #a09c94;
  font-family: sans-serif;
}
</style>
